import { Stack, styled } from "@mui/material";

export const ButtonsContainer = styled(Stack)`
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  gap: 10px;
`;
